import React from 'react';

export default ({ color = '#FFF' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" strokeLinecap="round">
      <g stroke={color}>
        <g>
          <g>
            <g transform="translate(-1120 -88) translate(0 68) translate(1120 20) translate(4.5 4.5)">
              <rect width="6" height="6" x="9" y="9" rx="1" />
              <rect width="6" height="6" y="9" rx="1" />
              <rect width="6" height="6" x="9" rx="1" />
              <rect width="6" height="6" rx="1" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
